import React from 'react';
import Box from 'v2/components/UI/Box';
import Text from 'v2/components/UI/Text';
import RenderGraphBar from '../../UI/BarChart';
import Icon from 'v2/components/Icon';
import MultiSelectAll from 'components/MultiSelect';
import useNurseryMortality from './hooks/useNurseryMortality';

const NurseryMortality: React.FC = () => {
  const { mortalityData, selectedShrimpPonds, setSelectedShrimpPonds } =
    useNurseryMortality();

  const renderTextEmptyMessageOrGraph = () => {
    if (mortalityData.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Nenhum dado encontrado
          </Text>
        </Box>
      );
    }

    if (selectedShrimpPonds.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Selecione ao menos um viveiro.
          </Text>
        </Box>
      );
    }
    return (
      <RenderGraphBar
        isPercentage
        data={selectedShrimpPonds}
        color={'#005f47'}
        dataKeyBar={'mortalities_percentage'}
        dataKeyXAxis="pond_name"
        name="Porcentagem de animais mortos"
      />
    );
  };
  return (
    <Box
      flexDirection="column"
      gap={30}
      padding={30}
      background="#fff"
      borderRadius={18}
    >
      <Box gap={10} alignItems="center">
        <Icon iconName="BloodtypeOutlined" htmlColor="#005f47" size={30} />
        <Text fontSize={24} fontWeight={700} color="#005f47">
          Mortalidade por Viveiro
        </Text>
      </Box>

      <Box width={'fit-content'}>
        <MultiSelectAll
          label="Viveiros"
          id="parameter"
          allSelected={mortalityData?.length === selectedShrimpPonds?.length}
          labelOption="pond_name"
          options={mortalityData}
          value={selectedShrimpPonds}
          onChange={setSelectedShrimpPonds}
          placeholder="Selecione um viveiro"
          error={false}
          helperText={false}
          renderOptionLabel={false}
          labelSelectAllButtonFilterOptions={false}
          labelCustomRenderOption={false}
        />
      </Box>
      {renderTextEmptyMessageOrGraph()}
    </Box>
  );
};

export default NurseryMortality;
